import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectSaved, selectSaving, selectError, selectCourse } from '../selectors/course.selector';
import { courseActions } from '../actions/course.actions';
import { CourseValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class CourseFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly saving$ = this.store.select(selectSaving);
    readonly course$ = this.store.select(selectCourse);
    readonly courseNonNullable$ = this.store.select(selectCourse).pipe(filter((course) => course !== null));

    readonly course = this.store.selectSignal(selectCourse);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = this.store.selectSignal(selectError);

    getCourse(id: string): void {
        this.store.dispatch(courseActions.getCourse({ id }));
    }

    createCourse(value: CourseValue): void {
        this.store.dispatch(courseActions.createCourse({ value }));
    }

    updateCourse(id: string, value: CourseValue): void {
        this.store.dispatch(courseActions.updateCourse({ id, value }));
    }

    deleteCourse(id: string): void {
        this.store.dispatch(courseActions.deleteCourse({ id }));
    }

    clear(): void {
        this.store.dispatch(courseActions.clear());
    }
}
